import styled from "styled-components"

const Splitter = styled.div`
  margin: 24px auto;
  height: 2px;
  max-width: 200px;
  background-color: var(--mainColor);
`

export const SmSplitter = styled.div`
  margin: 16px auto;
  height: 1px;
  max-width: 160px;
  background-color: var(--mainColor);
`
export default Splitter
